import axios from 'axios';

const axiosInstance = axios.create({
  timeout: 1000000,
  headers: { 'Content-Type': 'application/json' }
});

export const setBaseURL = (url: string) => {
  axiosInstance.defaults.baseURL = url;
};

axiosInstance.interceptors.request.use(
  (config: any) => {
    const accessToken = localStorage.getItem('token');
    const userId = localStorage.getItem('userid');
    if (accessToken) {
      config.headers.Authorization = `Bearer ${accessToken}`;
    }
    if (userId) {
      config.headers['userid'] = userId;
    }
    return config;
  },
  (error) => {
    return Promise.reject(error);
  }
);

// Handle errors and redirect for 401
axiosInstance.interceptors.response.use(
  (response) => {
    return response;
  },
  (error) => {
    if (error.response?.status === 401) {
      // Clear localstorage
      localStorage.clear();

      localStorage.setItem(
        'ErrorMessage',
        'Session expired, please login again.'
      );
      window.location.href = '/error';
    }
    return Promise.reject(error);
  }
);


export default axiosInstance;
